/**
 * 全ての組織を保持する。
 * 絞り込みが必要な場合は個別に実装する必要あり。
 */
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const organizeMstRepository = RepositoryFactory.get("organizeMst");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setOrganizeMst(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadOrganizeMst(context, screenId) {
    const list = await organizeMstRepository.list(screenId);
    if (list.status < 300) {
      context.commit("setOrganizeMst", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
